import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ContentService } from 'src/app/views/content/content.service';
import { MaterialModule } from '../../material.module';
import { AppPopContentComponent } from '../../services/app-pop-content/app-pop-content.component';
import { CustomPaginatorComponent } from '../custom-paginator/custom-paginator.component';

@Component({
  selector: 'app-content-searcher',
  templateUrl: './content-searcher.component.html',
  styleUrls: ['./content-searcher.component.scss'],
  standalone: true,
  imports: [MaterialModule, TranslateModule, CustomPaginatorComponent],
})
export class ContentSearcherComponent implements OnInit {
  constructor(
    private contentService: ContentService,
    private dialogRef: MatDialogRef<ContentSearcherComponent>,
    public translate: TranslateService,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  results = [];
  pageIndex = 0;
  pageSizeOptions = [5, 10, 20];
  pageSize = this.pageSizeOptions[0];
  totalSize = 0;
  preFirstSearch = true;
  loading = false;
  excludeList = [];
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  ngOnInit(): void {
    this.excludeList = this.data?.exclude || [];
  }

  onSearch(value): void {
    this.loading = true;
    this.preFirstSearch = false;
    this.contentService.searchContent(value, this.pageIndex, this.pageSize).subscribe(
      (res) => {
        this.loading = false;
        this.results = res.results;
        this.totalSize = res.total;

        if (this.data?.onlyContent) {
          this.results = this.results.filter((element) => element.contentID);
        }
        this.results = this.results.map((element) => {
          element.alreadyAdded = this.excludeList.includes(element._id);
          return element;
        });
      },
      (err) => {
        this.loading = false;
        this.results = [];
      }
    );
  }

  selectElement(element) {
    this.dialogRef.close(element);
  }

  onPageChange(event) {
    this.pageIndex = event.page;
    this.pageSize = event.pageSize;
    this.onSearch(this.searchInput.nativeElement.value);
  }

  openInNewTab(element) {
    let url = '';
    switch (element.type) {
      case 'lecture':
        url = `/knowledge/displayer/${element.courseID}/${element.sectionID}/${element.id}`;
        break;
      case 'blog':
        url = `/articles/${element.id}`;
        break;
      case 'note':
        url = `/notes/${element.id}`;
        break;
    }
    const fullURL = this.router.serializeUrl(this.router.createUrlTree([url]));
    window.open(fullURL, '_blank');
  }

  visualizeContent(element) {
    this.dialog.open(AppPopContentComponent, {
      data: { contentID: element.contentID },
    });
  }
  async loadContent(element, index) {
    if (!this.results[index].content) {
      this.contentService.getContentText(element.contentID).subscribe((res) => {
        this.results[index].content = this._sanitizer.bypassSecurityTrustHtml(res.content);
      });
    }
    // });
  }
  emptyContent(element, index) {
    delete this.results[index].content;
  }
}
